import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import moduleInfo from './modules/mixins/module-info'
Vue.mixin(moduleInfo)

import routeAnimatorClient from './modules/lib/route-animations/route-animator-client'
Vue.mixin(routeAnimatorClient)

import networkInterface from './modules/lib/network-interface/network-interface-mixin'
Vue.mixin(networkInterface)

const THEME_STORAGE_KEY = 'svb-theme'
const SUPPORTED_THEMES = ['classic', 'event-sunset']

function resolveThemeName() {
  const params = new URLSearchParams(window.location.search)
  const queryTheme = params.get('theme')
  if (queryTheme && SUPPORTED_THEMES.includes(queryTheme)) {
    localStorage.setItem(THEME_STORAGE_KEY, queryTheme)
    return queryTheme
  }
  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY)
  if (storedTheme && SUPPORTED_THEMES.includes(storedTheme)) {
    return storedTheme
  }
  return 'classic'
}

function applyTheme(themeName) {
  document.documentElement.setAttribute('data-theme', themeName)
}

applyTheme(resolveThemeName())

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js').then(registration => {
//       console.log('SW registered: ', registration);
//     }).catch(registrationError => {
//       console.log('SW registration failed: ', registrationError);
//     });
//   });
// }

new Vue({
  router,
  el: '#app',
  store,
  render: h => h(App),
})
